import React, { Component } from "react";
import moment from "moment";
moment.locale("fr", {
  months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
    "_"
  ),
  monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
    "_"
  ),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  },
  calendar: {
    sameDay: "[Aujourd’hui à] LT",
    nextDay: "[Demain à] LT",
    nextWeek: "dddd [à] LT",
    lastDay: "[Hier à] LT",
    lastWeek: "dddd [dernier à] LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function(number) {
    return number + (number === 1 ? "er" : "e");
  },
  meridiemParse: /PD|MD/,
  isPM: function(input) {
    return input.charAt(0) === "M";
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function(hours, minutes, isLower) {
    return hours < 12 ? "PD" : "MD";
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});

class AtelierDetail extends Component {
  state = {};
  render() {
    const catAtelier = this.props.categories
      .filter(cat => cat.id === this.props.data.categories[0])
      .map(cat => cat.name);

    const catColor = this.props.categories
      .filter(cat => cat.id === this.props.data.categories[0])
      .map(cat => cat.acf.selectionner_une_couleur);

    const catDesc = this.props.categories
      .filter(cat => cat.id === this.props.data.categories[0])
      .map(cat => cat.description);

    let date = new moment(this.props.data.acf.ateliers_date, "M-D-YYYY");
    date = date.format("dddd D MMMM");

    return (
      <div className="page-atelier">
        <main className="site-main">
          <div className="content">
            <section className="atelier_detail">
              <article>
                <div className="col3_2 ">
                  <div className="col2">
                    <div className="atelier_cat">
                      {<p className={"btn " + catColor}>{catAtelier}</p>}
                      {<p className={"cat_desc " + catColor}>{catDesc}</p>}
                    </div>
                    <header className="entry-header">
                      <h1
                        className={"entry-title " + catColor}
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.data.title &&
                            this.props.data.title.rendered
                        }}
                      >
                        {/* {this.props.data.title &&
                          this.props.data.title.rendered} */}
                      </h1>
                    </header>
                  </div>
                  <div className="col2">
                    <img
                      src={
                        this.props.data._embedded &&
                        this.props.data._embedded["wp:featuredmedia"] &&
                        this.props.data._embedded["wp:featuredmedia"].map(
                          l => l.source_url
                        )
                      }
                      alt=""
                    />
                  </div>
                  <div>
                    <div
                      className="entry-content"
                      dangerouslySetInnerHTML={{
                        __html:
                          this.props.data.content &&
                          this.props.data.content.rendered
                      }}
                    />
                  </div>
                </div>
                <div className={"encart " + catColor}>
                  <div>
                    <p className="date">
                      {this.props.data.acf && date}
                      <span>
                        {this.props.data.acf &&
                          this.props.data.acf.ateliers_heure_debut}{" "}
                        -{" "}
                        {this.props.data.acf &&
                          this.props.data.acf.ateliers_heure_fin}
                      </span>
                    </p>
                    <p className="localisation">
                      {this.props.data.acf &&
                        this.props.data.acf.ateliers_localisation}
                    </p>
                  </div>
                  <div className="atelier_ambassadrice">
                    {/* <p>Organisé par</p>{" "}
                    <div className="atelier_ambassadrice_detail">
                      <a
                        href={
                          "/ambassadrice/?id=" +
                          this.props.data.acf.ateliers_ambassadrice.ID
                          // this.props.ambassadrices
                          //   .filter(
                          //     amb =>
                          //       amb.id ===
                          //       this.props.data.acf.ateliers_ambassadrice.ID
                          //   )
                          //   .map(amb => amb.slug)
                        }
                      >
                        <img
                          src={
                            this.props.data &&
                            this.props.ambassadrices
                              .filter(
                                a =>
                                  a.id ===
                                  this.props.data.acf.ateliers_ambassadrice.ID
                              )
                              .map(a => a.acf.ambassadrice_photo)
                          }
                          alt=""
                        />
                        <div>
                          <p className="ambassadrice_nom">
                            {this.props.data.acf &&
                              this.props.data.acf.ateliers_ambassadrice
                                .display_name}
                          </p>
                          <p className="localisation">
                            {this.props.data &&
                              this.props.ambassadrices
                                .filter(
                                  a =>
                                    a.id ===
                                    this.props.data.acf.ateliers_ambassadrice.ID
                                )
                                .map(a => a.acf.ambassadrice_ville)}
                          </p>
                        </div>
                      </a>
                    </div> */}
                    <a
                      // href={"/les-ateliers/?id=" + this.props.data.id}
                      href="#modal"
                      className="btn bleu_f"
                      onClick={() =>
                        this.props.emailModal(
                          this.props.data.acf.ateliers_ambassadrice.user_email,
                          "nom atelier : " +
                            this.props.data.title.rendered +
                            " / date : " +
                            this.props.data.acf.ateliers_date +
                            " / heure début : " +
                            this.props.data.acf.ateliers_heure_debut
                        )
                      }
                    >
                      s'inscrire
                    </a>
                  </div>
                </div>
              </article>
            </section>
          </div>
        </main>
      </div>
    );
  }
}

export default AtelierDetail;



// WEBPACK FOOTER //
// ./src/Components/AtelierDetail.jsx